var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666992 40.9998C0.666992 18.4598 18.9603 0.166504 41.5003 0.166504C64.0403 0.166504 82.3337 18.4598 82.3337 40.9998C82.3337 63.5398 64.0403 81.8332 41.5003 81.8332C18.9603 81.8332 0.666992 63.5398 0.666992 40.9998ZM33.3337 49.8607L60.2428 22.9516L66.0003 28.7499L33.3337 61.4166L17.0003 45.0832L22.7578 39.3257L33.3337 49.8607Z",
    fill: "#0E067D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-check.f9c93143.svg";
export { ForwardRef as ReactComponent };